module.exports = __webpack_public_path__ + "static/media/flow-monitor-info-alert.55df5370.svg";